'use client'

import styles from '@/styles/main.scss'

import Script from 'next/script'
import React, { useRef } from 'react'

import { DashboardContextProvider } from '@/contexts/DashboardContextProvider/DashboardContextProvider'
import Sidebar from '/components/Sidebar/Sidebar'

import layoutStyles from './layout.module.scss'
import classNames from 'classnames/bind'
import GoogleTagManager from '@/components/GoogleTagManager/GoogleTagManager'
import Hubspot from '@/components/Hubspot/HubspotChat'
import { SessionTimeout } from '@/components/SessionTimeout/SessionTimeout'

const classes = classNames.bind(layoutStyles)

export default function RootLayout({ children }) {
    const sidebarRef = useRef(null)

    return (
        <>
            <title>Taxd - Dashboard</title>
            <link rel="icon" href="/favicon.png" type="image/png" sizes="16x16" />
            <Hubspot />
            <body>
                <GoogleTagManager />
                <DashboardContextProvider>
                    <div className={classes('layout')}>
                        <Sidebar sidebarRef={sidebarRef} />
                        <div className={classes('main')}>{children}</div>
                    </div>
                </DashboardContextProvider>
                <SessionTimeout />
            </body>
        </>
    )
}
